export default "__VITE_ASSET__5c6cf0eb__"